import React from "react";
import { NavLink } from "react-router-dom";

import styled from "styled-components/macro";

import unoPiggyBankNavy from "Payments/FundItPage/images/uno-piggy-bank-navy.png";
import ItemResults from "Signups/SharedComponents/ItemResults";
import classNames from "classnames";

import "./SignupSummary.scss";

export default function SignupSummary({
  ID,
  title,
  totalConfirmedSignups,
  totalAvailableSlots,
  index,
  total,
  isActive,
  signupListTypeID,
  hasSignupCost,
  // ...props
}) {
  // if you have a ton of signups this delays the progress bar animation by a really long time
  // if index is 200, then you start with a 20 sec delay
  // const progressBarDelay = index / 10 + (total - 2) / 100;
  const progressBarDelay = index / 10; // this still cascades the animation, but much quicker
  const isPollType = signupListTypeID === 4;

  return (
    <NavLink
      to={"/signups/" + ID}
      className="SignupSummary"
      activeClassName="on"
    >
      <div className="inside">
        <Info>
          <Title>{title}</Title>
          {hasSignupCost ? <Icon src={unoPiggyBankNavy} /> : null}
        </Info>

        {isActive && (
          <ItemResults
            count={totalConfirmedSignups}
            max={totalAvailableSlots}
            delay={progressBarDelay}
            width={260}
            hideProgressBar={isPollType}
            signupListTypeID={signupListTypeID}
          />
        )}
      </div>
    </NavLink>
  );
}

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
`;

const Icon = styled.img`
  display: block;
  margin-right: -4px;
  height: 28px;
  width: 28px;
  opacity: 0.95;
`;
